import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { BooleanInput } from 'shared/react-admin/Inputs';

export const BoxStyled = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  width: '100%',
  gap: '4px 24px',
});

export const BooleanInputStyled = styled(BooleanInput)({
  marginBottom: '24px',
  '& .MuiFormControlLabel-root': { marginRight: 0 },
});
